import { useLocation } from 'react-router-dom';
import './AppBackdrop.css';

// AppBackdrop — фотография-фон под всеми экранами, как в приложении (14.09.2026).
//
// ЗАЧЕМ. В приложении КАЖДЫЙ экран стоит на одной и той же фотографии клубной комнаты
// с затемнением (BlotMeUI.PhotoBackdrop). На сайте фон был плоской заливкой, и экраны
// выглядели чужими рядом с приложением — Адек это и назвал первым.
//
// ОДИН СЛОЙ НА ВСЕ СТРАНИЦЫ, а не по копии в каждой: иначе фон неизбежно разъедется —
// где-то забудут, где-то поставят своё затемнение.
//
// ЗАТЕМНЕНИЕ РАЗНОЕ И ЭТО НЕ СЛУЧАЙНОСТЬ — числа взяты из билдеров приложения:
//   главная            0.42  (HomeSceneBuilder)      — фотография работает сама
//   внутренние экраны  0.82  (Store/Friends/Profile/Settings/Compete) — читаемость списков
//   вход и регистрация 0.55  (Login/Register/Forgot) — между тем и другим
// Низ гасим ГРАДИЕНТОМ, а не плашкой: плашка даёт жёсткий шов посреди экрана.

const SCRIM = {
  '/app': 0.42,
  '/login': 0.55,
  '/register': 0.55,
  '/forgot-password': 0.55,
  '/reset-password': 0.55,
  '/verify-email': 0.55,
};
const INNER = 0.82;

// Страницы, у которых фон СВОЙ и фотография им мешает: игровой стол (там своя комната),
// лендинг и правовые документы (публичные страницы со своим оформлением), админка.
const OWN_BACKGROUND = ['/', '/play', '/get', '/legal', '/admin', '/join', '/delete-account'];

const AppBackdrop = () => {
  const { pathname } = useLocation();
  if (OWN_BACKGROUND.some((p) => (p === '/' ? pathname === '/' : pathname.startsWith(p)))) return null;

  const scrim = SCRIM[pathname] ?? INNER;
  return (
    <div className="bb-backdrop" aria-hidden="true">
      {/* ДВА КАДРА ОДНОЙ КОМНАТЫ (14.09.2026). Фотография приложения снята под телефон —
          768×1376. На мониторе «заполнить с обрезкой» показывает от неё только верхнюю
          полосу: потолок и люстру, а самой комнаты не видно. Поэтому на широких экранах
          берём горизонтальный кадр того же клуба, на узких — телефонный. Выбор делает
          CSS по пропорциям окна, без рассуждений в коде. */}
      <div
        className="bb-backdrop-photo bb-photo-wide"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/club_wide.jpg)` }}
      />
      <div
        className="bb-backdrop-photo bb-photo-tall"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/home_club.jpg)` }}
      />
      <div className="bb-backdrop-scrim" style={{ background: `rgba(15, 25, 35, ${scrim})` }} />
      <div className="bb-backdrop-bottom" />
    </div>
  );
};

export default AppBackdrop;
